var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPermissions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.909,
    height: 21.955,
    viewBox: "0 0 22.909 21.955",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -10.667)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 25.94)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.955,354.386H19.413a3.319,3.319,0,0,0-6.371,0H.955a.955.955,0,0,0,0,1.909H13.042a3.319,3.319,0,0,0,6.371,0h2.542a.955.955,0,0,0,0-1.909Zm-5.727,2.386a1.432,1.432,0,1,1,1.432-1.432A1.434,1.434,0,0,1,16.227,356.773Z",
    transform: "translate(0 -352)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 10.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.955,13.053H19.413a3.319,3.319,0,0,0-6.371,0H.955a.955.955,0,0,0,0,1.909H13.042a3.319,3.319,0,0,0,6.371,0h2.542a.955.955,0,0,0,0-1.909ZM16.227,15.44a1.432,1.432,0,1,1,1.432-1.432A1.434,1.434,0,0,1,16.227,15.44Z",
    transform: "translate(0 -10.667)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 18.303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.955,183.72H9.867a3.319,3.319,0,0,0-6.371,0H.955a.955.955,0,0,0,0,1.909H3.5a3.319,3.319,0,0,0,6.371,0H21.955a.955.955,0,0,0,0-1.909ZM6.682,186.107a1.432,1.432,0,1,1,1.432-1.432A1.434,1.434,0,0,1,6.682,186.107Z",
    transform: "translate(0 -181.334)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermissions);
export default __webpack_public_path__ + "static/media/permissions.4a538d4353816e724c85fc4f6960f330.svg";
export { ForwardRef as ReactComponent };